// Encrypt (encode)
import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_CRYPTO_KEY;

// Encrypt the id
export const encryptId = (id) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(
      id.toString(),
      SECRET_KEY,
    ).toString();

    return encodeURIComponent(encrypted); // URL safe
  } catch (err) {
    return id;
  }
};

// Decrypt the id
export const decryptId = (encodedId) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      decodeURIComponent(encodedId),
      SECRET_KEY,
    );

    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    return encodedId;
  }
};



